import type { Resource } from '../../';
export const general_addToCart: Resource = {"default":"Add to Bag"};
